<div class="card-body">
  <!-- Loader pierwszego wejscia (gdy pasek narzedzi jeszcze ukryty) -->
  <div *ngIf="isLoading && campaigns.length === 0 && !filtersApplied" class="text-center py-10">
      <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">{{ 'CAMPAIGN.LOADING' | translate }}</span>
      </div>
      <div class="mt-3 fs-6 fw-semibold text-gray-700">{{ 'CAMPAIGN.LOADING_CONTACTS' | translate }}</div>
  </div>

  <!-- Kampania bez kontaktow (po zaladowaniu, bez zastosowanego filtra) -->
  <div *ngIf="!isLoading && campaigns.length === 0 && !filtersApplied" class="alert alert-info d-flex flex-wrap align-items-center justify-content-between">
      <span>{{ 'CAMPAIGN.NO_CONTACTS' | translate }}</span>
      <button type="button" class="btn btn-sm btn-light-primary ms-3" [disabled]="isLoading || isReloading" (click)="onManualRefresh()">
          <i class="fa-solid fa-rotate-right" [class.fa-spin]="isLoading || isReloading"></i> {{ 'CAMPAIGN.REFRESH' | translate }}
      </button>
  </div>
  <!-- Pasek narzedzi: pokaz gdy sa dane LUB zastosowano filtr (by mozna bylo zmienic/wyczyscic filtr) -->
  <div *ngIf="campaigns.length > 0 || filtersApplied">
      <div class="d-flex flex-column align-items-end position-relative mb-5">
          <!-- Wiersz: lewa strona (Auto-odswiez) + prawa strona (filtry/odswiez) -->
          <div class="d-flex align-items-center justify-content-between w-100">
              <!-- Lewa strona: opcjonalne auto-odswiezanie co 10s -->
              <button type="button" class="btn btn-sm auto-refresh-btn"
                      [ngClass]="autoRefreshEnabled ? 'btn-success' : 'btn-light'"
                      [class.is-active]="autoRefreshEnabled"
                      (click)="toggleAutoRefresh()"
                      [title]="'CAMPAIGN.AUTO_REFRESH_TOOLTIP' | translate">
                  <i class="fa-solid" [ngClass]="autoRefreshEnabled ? 'fa-pause' : 'fa-arrows-rotate'"></i>
                  {{ 'CAMPAIGN.AUTO_REFRESH' | translate }}
              </button>
          <!-- Small Filter Button Aligned to the Right -->
          <!-- Button Group Wrapper to Align Both Buttons in a Row -->
          <div class="d-flex align-items-center">
              <!-- Existing Filter Button -->
              <button type="button" class="btn btn-sm" #filterButton [ngClass]="{
          'btn-success': filtersApplied && !errorMessage, 
          'btn-danger': errorMessage, 
          'btn-light': !filtersApplied && !errorMessage
          }" (click)="toggleFilterVisibility()">
                  <i class="fa-regular fa-filter fs-5"></i> {{ 'TRANSLATIONS.FILTER' | translate }}
              </button>
              <!-- New Button to Open the Filter Modal, placed right next to the Filter button -->
              <button class="btn btn-light btn-sm ms-3" data-bs-toggle="tooltip" title="{{ 'CAMPAIGN.FILTER_COLUMNS' | translate }}" (click)="openFilterModal()">
                  <i class="fa-regular fa-eye"></i> {{ 'CAMPAIGN.FILTER_COLUMNS' | translate }}
              </button>
              <!-- Manualne odswiezenie tabeli (auto-polling wylaczony) -->
              <button class="btn btn-light btn-sm ms-3" [disabled]="isLoading || isReloading" title="{{ 'CAMPAIGN.REFRESH' | translate }}" (click)="onManualRefresh()">
                  <i class="fa-solid fa-rotate-right" [class.fa-spin]="isLoading || isReloading"></i> {{ 'CAMPAIGN.REFRESH' | translate }}
              </button>
          </div>
          </div>
          <!-- Error Message Displayed Under the Button -->
          <div *ngIf="errorMessage" class="text-danger mt-2">
              {{ errorMessage }}
          </div>
          <div *ngIf="isFilterVisible" class="menu menu-sub menu-sub-dropdown w-300px w-md-325px show position-absolute" style="z-index: 107; top: 100%; right: 0;" #filterDropdown>
              <!-- Add a template reference variable -->
              <!-- Filter Dropdown Content -->
              <div class="px-7 py-5">
                  <div class="fs-5 text-gray-900 fw-bold">{{ 'TRANSLATIONS.FILTER_OPTIONS' | translate }}</div>
              </div>
              <div class="separator border-gray-200"></div>
              <!-- Filter Inputs -->
              <div class="px-7 py-5" data-kt-subscription-table-filter="form">
                  <div class="row">
                      <!-- Status Filter -->
                      <div class="col-md-12 mb-3">
                          <label class="form-label fs-6 fw-semibold">{{ 'TRANSLATIONS.STATUS' | translate }}</label>
                          <select [(ngModel)]="tempFilterValues.status" class="form-select form-select-solid fw-bold">
                              <option value="">{{ 'TRANSLATIONS.ALL_STATUSES' | translate }}</option>
                              <option value="0">{{ getStatusText(0) }}</option>
                              <option value="1">{{ getStatusText(1) }}</option>
                              <option value="2">{{ getStatusText(2) }}</option>
                              <option value="3">{{ getStatusText(3) }}</option>
                              <option value="4">{{ getStatusText(4) }}</option>
                              <option value="5">{{ getStatusText(5) }}</option>
                              <option value="6">{{ getStatusText(6) }}</option>
                          </select>
                      </div>
                      <!-- Phone Filter -->
                      <div class="col-md-12 mb-3">
                          <label class="form-label fs-6 fw-semibold">{{ 'TRANSLATIONS.PHONE' | translate }}</label>
                          <input type="text" [(ngModel)]="tempFilterValues.phone" placeholder="{{ 'TRANSLATIONS.SEARCH_PHONE' | translate }}" class="form-control form-control-sm" />
                      </div>
                      <!-- Call Date Range Filter (call_at) -->
                      <div class="col-md-12 mb-3">
                          <label class="form-label fs-6 fw-semibold">{{ 'TRANSLATIONS.CALL_DATE' | translate }}</label>
                          <select [(ngModel)]="tempFilterValues.call_at" class="form-select form-select-solid fw-bold">
                              <option value="">{{ 'TRANSLATIONS.ALL_DATES' | translate }}</option>
                              <option value="1">{{ 'TRANSLATIONS.LAST_1_DAYS' | translate }}</option>
                              <option value="7">{{ 'TRANSLATIONS.LAST_7_DAYS' | translate }}</option>
                              <option value="14">{{ 'TRANSLATIONS.LAST_14_DAYS' | translate }}</option>
                              <option value="30">{{ 'TRANSLATIONS.LAST_30_DAYS' | translate }}</option>
                              <option value="60">{{ 'TRANSLATIONS.LAST_60_DAYS' | translate }}</option>
                              <option value="90">{{ 'TRANSLATIONS.LAST_90_DAYS' | translate }}</option>
                          </select>
                      </div>
                      <!-- Date Range Filter -->
                      <div class="col-md-12 mb-3">
                          <label class="form-label fs-6 fw-semibold">{{ 'TRANSLATIONS.CREATED_DATE' | translate }}</label>
                          <select [(ngModel)]="tempFilterValues.created" class="form-select form-select-solid fw-bold">
                              <option value="">{{ 'TRANSLATIONS.ALL_DATES' | translate }}</option>
                              <option value="1">{{ 'TRANSLATIONS.LAST_1_DAYS' | translate }}</option>
                              <option value="7">{{ 'TRANSLATIONS.LAST_7_DAYS' | translate }}</option>
                              <option value="14">{{ 'TRANSLATIONS.LAST_14_DAYS' | translate }}</option>
                              <option value="30">{{ 'TRANSLATIONS.LAST_30_DAYS' | translate }}</option>
                              <option value="60">{{ 'TRANSLATIONS.LAST_60_DAYS' | translate }}</option>
                              <option value="90">{{ 'TRANSLATIONS.LAST_90_DAYS' | translate }}</option>
                          </select>
                      </div>
                      <!-- Modified Date Range Filter -->
                      <div class="col-md-12 mb-3">
                          <label class="form-label fs-6 fw-semibold">{{ 'TRANSLATIONS.MODIFIED_DATE' | translate }}</label>
                          <select [(ngModel)]="tempFilterValues.modified" class="form-select form-select-solid fw-bold">
                              <option value="">{{ 'TRANSLATIONS.ALL_DATES' | translate }}</option>
                              <option value="1">{{ 'TRANSLATIONS.LAST_1_DAYS' | translate }}</option>
                              <option value="7">{{ 'TRANSLATIONS.LAST_7_DAYS' | translate }}</option>
                              <option value="14">{{ 'TRANSLATIONS.LAST_14_DAYS' | translate }}</option>
                              <option value="30">{{ 'TRANSLATIONS.LAST_30_DAYS' | translate }}</option>
                              <option value="60">{{ 'TRANSLATIONS.LAST_60_DAYS' | translate }}</option>
                              <option value="90">{{ 'TRANSLATIONS.LAST_90_DAYS' | translate }}</option>
                          </select>
                      </div>
                      <!-- Call Attempts Filter -->
                      <div class="col-md-12 mb-3">
                          <label class="form-label fs-6 fw-semibold">{{ 'TRANSLATIONS.CALL_ATTEMPTS' | translate }}</label>
                          <input type="number" [(ngModel)]="tempFilterValues.call_number" placeholder="{{ 'TRANSLATIONS.SEARCH_CALL_NUMBER' | translate }}" class="form-control form-control-sm" />
                      </div>
                      <!-- Type Filter -->
                      <div class="col-md-12 mb-3">
                          <label class="form-label fs-6 fw-semibold">{{ 'TRANSLATIONS.TYPE' | translate }}</label>
                          <select [(ngModel)]="tempFilterValues.type" class="form-select form-select-solid fw-bold">
                              <option value="">{{ 'TRANSLATIONS.ALL_TYPES' | translate }}</option>
                              <option value="0">{{ 'TRANSLATIONS.OUTGOING_CALL' | translate }}</option>
                              <option value="1">{{ 'TRANSLATIONS.INCOMING_CALL' | translate }}</option>
                          </select>
                      </div>
                      <!-- Tag Filter — TYMCZASOWO UKRYTY (niedokonczony case na przyszlosc) -->
                      <div class="col-md-12 mb-3" *ngIf="false && availableTags.length > 0">
                          <label class="form-label fs-6 fw-semibold">{{ 'TRANSLATIONS.TAG' | translate }}</label>
                          <select [(ngModel)]="tempFilterValues.tag" class="form-select form-select-solid fw-bold">
                              <option value="">{{ 'TRANSLATIONS.ALL_TAGS' | translate }}</option>
                              <option *ngFor="let tag of availableTags" value="{{ tag.id }}">{{ tag.value }}</option>
                          </select>
                      </div>
                  </div>
                  <!-- Actions: Reset and Apply -->
                  <div class="d-flex justify-content-end">
                      <button type="button" class="btn btn-light btn-active-light-primary fw-semibold me-2 px-6" [ngClass]="{'btn-secondary': !filtersApplied && !errorMessage}" (click)="resetFilters()">
                          {{ 'TRANSLATIONS.RESET' | translate }}
                      </button>
                      <button type="button" class="btn btn-primary fw-semibold px-6" (click)="applyFilters()">
                          {{ 'TRANSLATIONS.APPLY' | translate }}
                      </button>
                  </div>
              </div>
          </div>
      </div>
      <!-- Loader podczas wczytywania (paginacja / filtr / odswiez) — chwilowo zastepuje tabele -->
      <div *ngIf="isLoading" class="text-center py-10">
          <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">{{ 'CAMPAIGN.LOADING' | translate }}</span>
          </div>
          <div class="mt-3 fs-6 fw-semibold text-gray-700">{{ 'CAMPAIGN.LOADING_CONTACTS' | translate }}</div>
      </div>
      <!-- Filtr nie zwrocil zadnych pasujacych kontaktow (pasek narzedzi pozostaje widoczny) -->
      <div *ngIf="!isLoading && campaigns.length === 0 && filtersApplied" class="alert alert-warning w-100 mt-3" role="alert">
          {{ 'CAMPAIGN.NO_FILTER_RESULTS' | translate }}
      </div>
      <div *ngIf="!isLoading && campaigns.length > 0" class="table-responsive">
          <table style="padding: 0px!important; margin: 0px!important;" class="table table-sm table-bordered table-hover table-row-gray-600 align-middle gs-10 ge-10">
              <thead class="table-sm">
                  <tr class="fw-bolder bg-primary" style="color: white!important">
                      <!-- Default Columns -->
                      <th *ngIf="filters.showID" class="min-w-20px" style="white-space: nowrap; cursor: pointer;" (click)="onSort('id')">
                          <span id="sort">{{ 'CAMPAIGN.ID' | translate }}</span>
                          <i [ngClass]="getSortIcon('id')"></i>
                      </th>
                      <th *ngIf="filters.showType" style="text-align: center; white-space: nowrap;" (click)="onSort('type')">
                          <span id="sort">{{ 'CAMPAIGN.TYPE' | translate }}</span>
                          <i [ngClass]="getSortIcon('type')"></i>
                      </th>
                      <th *ngIf="filters.showCreated" style="text-align: center; white-space: nowrap;" (click)="onSort('created')">
                          <span id="sort">{{ 'CAMPAIGN.CREATED' | translate }}</span>
                          <i [ngClass]="getSortIcon('created')"></i>
                      </th>
                      <th *ngIf="filters.showModified" style="text-align: center; white-space: nowrap;" (click)="onSort('modified')">
                          <span id="sort">{{ 'CAMPAIGN.MODIFIED' | translate }}</span>
                          <i [ngClass]="getSortIcon('modified')"></i>
                      </th>
                      <th *ngIf="filters.showCalledAt" style="text-align: center; white-space: nowrap;" (click)="onSort('call_at')">
                          <span id="sort">{{ 'CAMPAIGN.CALLED_AT' | translate }}</span>
                          <i [ngClass]="getSortIcon('call_at')"></i>
                      </th>
                      <th *ngIf="filters.showStatus" style="text-align: center; white-space: nowrap;" (click)="onSort('status')">
                          <span id="sort">{{ 'CAMPAIGN.STATUS' | translate }}</span>
                          <i [ngClass]="getSortIcon('status')"></i>
                      </th>
                      <!-- New Column for Scheduled -->
                      <th *ngIf="filters.showScheduled" style="text-align: center; white-space: nowrap;" (click)="onSort('scheduled')">
                          <span id="sort">{{ 'CAMPAIGN.SCHEDULED' | translate }}</span>
                          <i [ngClass]="getSortIcon('scheduled')"></i>
                      </th>
                      <th *ngIf="filters.showPhone" style="text-align: center; white-space: nowrap;" (click)="onSort('phone')">
                          <span id="sort">{{ 'CAMPAIGN.PHONE_NUMBER' | translate }}</span>
                          <i [ngClass]="getSortIcon('phone')"></i>
                      </th>
                      <th *ngIf="filters.showDuration" style="text-align: center; white-space: nowrap;" (click)="onSort('duration')">
                          <span id="sort">{{ 'CAMPAIGN.DURATION' | translate }}</span>
                          <i [ngClass]="getSortIcon('duration')"></i>
                      </th>
                      <th *ngIf="filters.showAttempts" style="text-align: center; white-space: nowrap;" (click)="onSort('call_number')">
                          <span id="sort">{{ 'CAMPAIGN.ATTEMPTS' | translate }}</span>
                          <i [ngClass]="getSortIcon('call_number')"></i>
                      </th>
                      <th *ngIf="filters.showShortcuts" style="text-align: center; white-space: nowrap;">
                          {{ 'CAMPAIGN.SHORTCUTS' | translate }}
                      </th>
                      <th style="text-align: center; white-space: nowrap;">{{ 'CAMPAIGN.TAGS' | translate }}</th>
                      <!-- Eliot Fields -->
                      <ng-container *ngIf="campaignModule === 'eliot'">
                          <th *ngIf="filters.showEliotID" style="text-align: center; white-space: nowrap;" class="min-w-120px">{{ 'CAMPAIGN.ELIOT_ID' | translate }}</th>
                          <th *ngIf="filters.showEliotName" style="text-align: center; white-space: nowrap;" class="min-w-120px">{{ 'CAMPAIGN.ELIOT_NAME' | translate }}</th>
                          <th *ngIf="filters.showEliotSurname" style="text-align: center; white-space: nowrap;" class="min-w-120px">{{ 'CAMPAIGN.ELIOT_SURNAME' | translate }}</th>
                          <th *ngIf="filters.showEliotCompany" style="text-align: center; white-space: nowrap;" class="min-w-120px">{{ 'CAMPAIGN.ELIOT_COMPANY' | translate }}</th>
                          <th *ngIf="filters.showEliotLink" style="text-align: center; white-space: nowrap;" class="min-w-120px">{{ 'CAMPAIGN.ELIOT_PROFILE_LINK' | translate }}</th>
                          <th *ngIf="filters.showEliotSync" style="text-align: center; white-space: nowrap;" class="min-w-120px">{{ 'CAMPAIGN.ELIOT_SYNC' | translate }}</th>
                          <th *ngIf="filters.showEliotSyncDate" style="text-align: center; white-space: nowrap;" class="min-w-120px">{{ 'CAMPAIGN.ELIOT_SYNC_DATE' | translate }}</th>
                      </ng-container>
                      <!-- IntegromatInvent1 Fields -->
                      <ng-container *ngIf="campaignModule === 'integromatInvent1'">
                          <th *ngIf="filters.showContactCampaignFrom" style="text-align: center; white-space: nowrap;" class="min-w-120px">{{ 'CAMPAIGN.CONTACT_CAMPAIGN_FROM' | translate }}</th>
                          <th *ngIf="filters.showContactEmail" style="text-align: center; white-space: nowrap;" class="min-w-120px">{{ 'CAMPAIGN.CONTACT_EMAIL' | translate }}</th>
                          <th *ngIf="filters.showContactJobFor" style="text-align: center; white-space: nowrap;" class="min-w-120px">{{ 'CAMPAIGN.CONTACT_JOB_FOR' | translate }}</th>
                          <th *ngIf="filters.showContactLanguageGrade" style="text-align: center; white-space: nowrap;" class="min-w-120px">{{ 'CAMPAIGN.CONTACT_LANGUAGE_GRADE' | translate }}</th>
                          <th *ngIf="filters.showContactName" style="text-align: center; white-space: nowrap;" class="min-w-120px">{{ 'CAMPAIGN.CONTACT_NAME' | translate }}</th>
                          <th *ngIf="filters.showContactSource" style="text-align: center; white-space: nowrap;" class="min-w-120px">{{ 'CAMPAIGN.CONTACT_SOURCE' | translate }}</th>
                          <th *ngIf="filters.showContactSubmit" style="text-align: center; white-space: nowrap;" class="min-w-120px">{{ 'CAMPAIGN.CONTACT_SUBMIT' | translate }}</th>
                          <th *ngIf="filters.showContactSurname" style="text-align: center; white-space: nowrap;" class="min-w-120px">{{ 'CAMPAIGN.CONTACT_SURNAME' | translate }}</th>
                      </ng-container>
                      <th class="action-column text-center" style="white-space: nowrap;">
                          {{ 'CAMPAIGN.ACTIONS' | translate }}
                      </th>
                   <th *ngIf="filters.showQuickActions && authService.hasRole(['superadmin', 'admin'])" 
   class="action-column text-center" style="white-space: nowrap;">
   {{ 'CAMPAIGN.QUICK_ACTIONS' | translate }}
</th>

                  </tr>
              </thead>
              <tbody>
                  <ng-container *ngFor="let campaign of campaigns; trackBy: trackByCampaignId">
                      <tr #campaignRow [ngClass]="{'expandable-row': !campaign.expanded, 'pointer-cursor': true}" (click)="toggleExpandRow(campaign, campaignRow)">
                          <td *ngIf="filters.showID" class="min-w-50px white-space: nowrap;">
                              <span (click)="copyToClipboard(campaign.public || '-', $event)" (mouseenter)="showFullId = campaign.public" (mouseleave)="showFullId = ''; copyInProgress = false" class="pointer-cursor" [attr.title]="campaign.public || '-'" [ngClass]="{'text-muted': copyInProgress}">
                   {{ showFullId === campaign.public || campaign.showFullId ? campaign.public || '-' : (campaign.public ? campaign.public.substring(0, 5) + '...' : '-') }}
                   </span>
                          </td>
                          <td *ngIf="filters.showType" style="text-align: center; white-space: nowrap;">
                              <span *ngIf="campaign.type === 0" [ngbTooltip]="'TOOLTIP.OUTGOING_CALL' | translate" container="body">
                   <i class="fa-solid fa-phone-arrow-up-right text-primary"></i>
                   </span>
                              <span *ngIf="campaign.type === 1" [ngbTooltip]="'TOOLTIP.INCOMING_CALL' | translate" container="body">
                   <i class="fa-solid fa-phone-arrow-down-left text-success"></i>
                   </span>
                          </td>
                          <td *ngIf="filters.showCreated" style="text-align: center; white-space: nowrap;">{{ campaign.created | timezoneDate }}</td>
                          <td *ngIf="filters.showModified" style="text-align: center; white-space: nowrap;">{{ campaign.modified | timezoneDate }}</td>
                          <td *ngIf="filters.showCalledAt" style="text-align: center; white-space: nowrap;">{{ campaign.call_at ? (campaign.call_at | timezoneDate) : '-' }}</td>
                          <td *ngIf="filters.showStatus" style="text-align: center; white-space: nowrap;">
                              <i [ngClass]="[getIcons(campaign.status, campaign.scheduled ?? null).icon, getStatusClass(campaign.status)]" [ngbTooltip]="getIcons(campaign.status, campaign.scheduled ?? null).tooltip" container="body" tooltipClass="custom-tooltip"></i>
                          </td>
                          <td *ngIf="filters.showScheduled" style="text-align: center; white-space: nowrap;">
                              <span>
                   {{ campaign.status === 0 && campaign.scheduled 
                   ? (campaign.scheduled | timezoneDate) 
                   : ('CAMPAIGN.NO_SCHEDULED' | translate) 
                   }}
                   </span>
                          </td>
                          <td *ngIf="filters.showPhone" style="text-align: center; white-space: nowrap;" #rowElement>
                           <!-- Conditionally show badge only if phone is in the map -->
                           <ng-container *ngIf="phoneColorMap.has(campaign.phone); else plainPhone">
                             <span
                               class="pointer-cursor badge rounded-pill px-3 py-2"
                               [ngStyle]="{ 'background-color': getPhoneColor(campaign.phone), color: '#fff' }"
                               (click)="toggleExpandRow(campaign, rowElement)">
                               {{ campaign.phone }}
                             </span>
                           </ng-container>
                         
                           <!-- Fallback plain number if not in DB -->
                           <ng-template #plainPhone>
                             <span class="pointer-cursor" (click)="toggleExpandRow(campaign, rowElement)">
                               {{ campaign.phone }}
                             </span>
                           </ng-template>
                         
                           <!-- Copy icon (shared for both cases) -->
                           <i class="fa-sharp fa-solid fa-copy ms-2 pointer-cursor"
                              (click)="copyToClipboard(campaign.phone, $event)"
                              [ngbTooltip]="getTooltipMessage(campaign.phone)"
                              container="body"
                              tooltipClass="custom-tooltip"
                              (click)="$event.stopPropagation()">
                           </i>
                         </td>
                         
                         
                         
                          <td *ngIf="filters.showDuration" style="text-align: center; white-space: nowrap;">
                              {{ campaign.status === 2 ? (campaign.duration ? formatCampaignDuration(campaign.duration) : '00:00:00') : '00:00:00' }}
                          </td>
                          <td *ngIf="filters.showAttempts" style="text-align: center; white-space: nowrap;">
                              <span class="badge badge-light-primary pointer-cursor" (click)="setPhoneFilter(campaign.phone, $event)">
                   {{ campaign.call_number }}
                   </span>
                          </td>
                          <td style="text-align: center; white-space: nowrap;" (click)="$event.stopPropagation()">
                              <div class="symbol-group symbol-hover flex-shrink-0" style="flex: none!important; display: inline-flex; align-items: center;">
                                  <!-- Loop through the tags specific to this campaign -->
                                  <ng-container *ngFor="let tag of campaign.tagsLetters; let i = index">
                                      <div class="symbol-container" style="display: inline-flex; align-items: center;">
                                          <div class="symbol symbol-circle symbol-25px" (click)="toggleTagExpansion(campaign, i, $event)" [attr.aria-expanded]="campaign.expandedIndex === i" [ngClass]="campaign.expandedIndex === i ? 'expanded-symbol symbol-expanded' : ''" [ngbTooltip]="tag.tooltip">
                                              <div class="symbol-label border border-body text-white fs-7" [style.backgroundColor]="tag.color">
                                                  {{ campaign.expandedIndex === i ? tag.fullName : tag.letter }}
                                              </div>
                                          </div>
                                          <!-- Show the "X" delete button only next to the expanded tag -->
                                          <div *ngIf="campaign.expandedIndex === i" class="symbol symbol-circle symbol-25px delete-button shadow-symbol" (click)="deleteTag(campaign, i, $event)" style="cursor: pointer;" title="Delete tag" aria-label="Delete tag">
                                              <div class="symbol-label fw-bolder text-white bg-danger">
                                                  <i class="fa-sharp fa-solid fa-xmark text-white fw-bolder fs-7"></i>
                                              </div>
                                          </div>
                                      </div>
                                  </ng-container>
                                  <!-- "+" symbol for adding a new tag (ALWAYS visible) -->
                                  <div class="symbol symbol-circle border border-body symbol-25px" (click)="openAddTagModal(campaign, $event)" style="cursor: pointer;" title="Add new tag" aria-label="Add new tag">
                                      <div class="symbol-label fw-bolder text-white bg-dark">
                                          <i class="fa-regular fa-plus text-white fw-bolder fs-9"></i>
                                      </div>
                                  </div>
                              </div>
                          </td>
                          <!-- Eliot Fields -->
                          <ng-container *ngIf="campaignModule === 'eliot'" style="white-space: nowrap;">
                              <td *ngIf="filters.showEliotID" style="text-align: center;">
                                  {{ campaign.eliotID || '-' }}
                              </td>
                              <td *ngIf="filters.showEliotName" style="text-align: center;">
                                  {{ campaign.eliotName || '-' }}
                              </td>
                              <td *ngIf="filters.showEliotSurname" style="text-align: center;">
                                  {{ campaign.eliotSurname || '-' }}
                              </td>
                              <td *ngIf="filters.showEliotCompany" style="text-align: center;">
                                  {{ campaign.eliotCompany || '-' }}
                              </td>
                              <td *ngIf="filters.showEliotLink" style="text-align: center;">
                                <ng-container *ngIf="campaign.eliotLink; else noLink">
                                  <a [href]="campaign.eliotLink.replace('%23', '#')" target="_blank" class="text-decoration-none"
                                     ngbTooltip="{{ 'TOOLTIP.OPEN_PROFILE' | translate }}">
                                    <i class="fa-sharp fa-regular fa-globe text-primary"></i>
                                  </a>
                                </ng-container>
                                <ng-template #noLink>-</ng-template>
                              </td>
                              
                              <td *ngIf="filters.showEliotSync && campaign?.eliotSync !== undefined" style="text-align: center;">
                                <ng-container [ngSwitch]="campaign.eliotSync">
                                  <i *ngSwitchCase="'0'" class="fa-regular fa-hourglass-clock text-info" 
                                     ngbTooltip="{{ 'TOOLTIP.PENDING' | translate }}"></i>
                                  <i *ngSwitchCase="'1'" class="fa-solid fa-check text-success" 
                                     ngbTooltip="{{ 'TOOLTIP.SYNCED' | translate }}"></i>
                                  <i *ngSwitchCase="'2'" class="fa-solid fa-xmark text-danger" 
                                     ngbTooltip="{{ 'TOOLTIP.ERROR' | translate }}"></i>
                                  <span *ngSwitchDefault>-</span>
                                </ng-container>
                              </td>
                              
                              <td *ngIf="filters.showEliotSyncDate" style="text-align: center;">
                                  {{ campaign.eliotSyncDate === '0' ? '-' : (campaign.eliotSyncDate | date: 'yyyy-MM-dd') }}
                              </td>
                          </ng-container>
                          <!-- IntegromatInvent1 Fields -->
                          <ng-container *ngIf="campaignModule === 'integromatInvent1'" style="white-space: nowrap;">
                              <td *ngIf="filters.showContactCampaignFrom" style="text-align: center;">{{ campaign.contactCampaignFrom }}</td>
                              <td *ngIf="filters.showContactEmail" style="text-align: center;">{{ campaign.contactEmail }}</td>
                              <td *ngIf="filters.showContactJobFor" style="text-align: center;">{{ campaign.contactJobFor }}</td>
                              <td *ngIf="filters.showContactLanguageGrade" style="text-align: center;">{{ campaign.contactLanguageGrade }}</td>
                              <td *ngIf="filters.showContactName" style="text-align: center;">{{ campaign.contactName }}</td>
                              <td *ngIf="filters.showContactSource" style="text-align: center;">{{ campaign.contactSource }}</td>
                              <td *ngIf="filters.showContactSubmit" style="text-align: center;">{{ campaign.contactSubmit }}</td>
                              <td *ngIf="filters.showContactSurname" style="text-align: center;">{{ campaign.contactSurname }}</td>
                          </ng-container>
                          <td class="text-center" style="white-space: nowrap;">
                              <!-- Action Buttons (Retry, Message, Play, Edit) -->
                              <!-- Retry Button -->
                              <button type="button" class="btn btn-icon w-30px h-30px me-3" [disabled]="selectedCampaignType === 0 || campaign.retry === 1 || (campaign.retry === 0 && campaign.status === 0 && campaign.scheduled) || campaign.eliotSync === '1'" (click)="onRetryContact(campaign.public); $event.stopPropagation()"
                              [ngbTooltip]="selectedCampaignType === 0 ? ('TOOLTIP.RETRY_INCOMING_DISABLED' | translate) : ('TOOLTIP.RETRY' | translate)" container="body" triggers="hover"
                              [ngClass]="{
   'btn-disabled': selectedCampaignType === 0 || campaign.retry === 1 || (campaign.retry === 0 && campaign.status === 0 && campaign.scheduled) || campaign.eliotSync === '1',
   'btn-active-light-primary': selectedCampaignType !== 0 && campaign.retry !== 1 && campaign.eliotSync !== '1'
 }">
                                  <i class="fa-solid fa-arrows-rotate text-dark"></i>
                              </button>

                              <!-- Message Notification Button -->
                              <button type="button" class="btn btn-icon w-30px h-30px me-3" [disabled]="!(campaign.status === 2 || campaign.status === 4)" (click)="toggleExpandRow(campaign, campaignRow); $event.stopPropagation()"
 [ngbTooltip]="'TOOLTIP.SHOW_TRANSCRIPTION' | translate" container="body" triggers="hover" [ngClass]="{
 'btn-disabled text-muted': !(campaign.status === 2 || campaign.status === 4),
 'text-success': campaign.chatMessagesSubject.value.length > 0,
 'text-muted': campaign.chatMessagesSubject.value.length === 0,
 'btn-active-light-primary': campaign.status === 2 || campaign.status === 4
 }">
                                  <i class="fa-solid fa-comment text-dark"></i>
                              </button>
                              <!-- Play/Pause Audio Button -->
                              <button type="button" class="btn btn-icon w-30px h-30px me-3" [disabled]="!(campaign.status === 2 || campaign.status === 4)" (click)="playTranscriptionAudio(campaign, $event); $event.stopPropagation()"
 [ngbTooltip]="'TOOLTIP.PLAY_RECORDING' | translate" container="body" triggers="hover" [ngClass]="{
 'btn-disabled': !(campaign.status === 2 || campaign.status === 4),
 'btn-active-light-primary': campaign.status === 2 || campaign.status === 4
 }">
                                  <i [ngClass]="(currentCampaignPlaying === campaign && !isPaused) ? 'fa-solid fa-pause text-dark' : 'fa-solid fa-play text-dark'"></i>
                              </button>
                              <!-- Edit Status Button -->
                            <button
 *ngIf="filters.showQuickActions && authService.hasRole(['superadmin', 'admin', 'manager', 'user'])"
 type="button"
 class="btn btn-icon w-30px h-30px me-3"
 [disabled]="campaign.retry === 1 || campaign.eliotSync === '1'"
 (click)="openEditStatusModal(campaign, $event); $event.stopPropagation()"
 [ngbTooltip]="'TOOLTIP.EDIT_STATUS' | translate" container="body" triggers="hover"
 [ngClass]="{
   'btn-disabled': campaign.retry === 1 || campaign.eliotSync === '1',
   'btn-active-light-primary': campaign.retry !== 1 && campaign.eliotSync !== '1'
 }">
 <i class="fa-solid fa-pen text-dark"></i>
</button>

                          </td>
                          <!-- Quick Actions Button -->
                          <td *ngIf="filters.showQuickActions && authService.hasRole(['superadmin', 'admin'])" class="text-center">
   <button [disabled]="campaign.status !== 2 || campaign.eliotSync === '1'" class="btn btn-icon w-30px h-30px me-3" (click)="quickActionPhoneMissed(campaign, $event)">
       <i class="fa-solid fa-phone-missed" [ngClass]="{'text-danger': campaign.status === 2}"></i>
   </button>
   <button [disabled]="campaign.status !== 2 || campaign.eliotSync === '1'" class="btn btn-icon w-30px h-30px me-3" (click)="quickActionPhoneRejected(campaign, $event)">
       <i class="fa-solid fa-phone-slash" [ngClass]="{'text-warning': campaign.status === 2}"></i>
   </button>
</td>

                          <!-- Expandable Row for Chat Messages -->
                          <tr *ngIf="campaign.expanded && (campaign.chatMessagesSubject | async)">
                              <td colspan="12" class="chat-message-row position-relative">
                                  <!-- Zwiniecie transkrypcji (X w prawym gornym rogu) -->
                                  <button type="button" class="btn btn-icon btn-sm position-absolute top-0 end-0 mt-2 me-2"
                                          style="z-index: 5;"
                                          (click)="collapseTranscription(campaign, $event)"
                                          [ngbTooltip]="'TOOLTIP.HIDE_TRANSCRIPTION' | translate" container="body" triggers="hover">
                                      <i class="fa-solid fa-xmark fs-4 text-muted"></i>
                                  </button>
                                  <ng-container *ngIf="(campaign.chatMessagesSubject | async) as messages">
                                      <ng-container *ngIf="messages && messages.length > 0; else noMessages">
                                          <div class="chat-inner-container">
                                              <app-chat-inner [messages]="campaign.chatMessagesSubject.asObservable()"></app-chat-inner>
                                          </div>
                                      </ng-container>
                                  </ng-container>
                                  <ng-template #noMessages>
                                      <div class="alert alert-info" role="alert">
                                          {{ 'CAMPAIGN.NO_RESPONSES' | translate }}
                                      </div>
                                  </ng-template>
                              </td>
                          </tr>
                  </ng-container>
              </tbody>
          </table>
          <div class="d-flex flex-stack flex-wrap pt-10 m-10">
              <app-audio-modal *ngIf="isAudioModalVisible" [audioUrl]="currentAudioUrl"></app-audio-modal>
              <div class="fs-6 fw-bold text-gray-700">
                  {{ 'TRANSLATIONS.SHOWING' | translate }} {{ startItem }} {{ 'TRANSLATIONS.TO' | translate }} {{ endItem }} {{ 'TRANSLATIONS.OF' | translate }} {{ totalItems }} {{ 'TRANSLATIONS.ENTRIES' | translate }}
              </div>
              <!-- Pagination Controls -->
              <ul class="pagination">
                  <!-- Previous Button -->
                  <li class="page-item" [class.disabled]="currentPage === 1">
                      <a class="page-link cursor-pointer" (click)="onPageChange(currentPage - 1)">
          {{ 'TRANSLATIONS.PREVIOUS' | translate }}
          </a>
                  </li>
                  <!-- Page Numbers -->
                  <li *ngFor="let page of pageNumbers; let i = index" class="page-item" [class.active]="page === currentPage">
                      <ng-container *ngIf="page === '...'; else normalPage">
                          <!-- Wielokropek: klik otwiera input "Idz do strony" -->
                          <span *ngIf="editingPageIndex === i; else ellipsisDots" class="page-link d-inline-flex align-items-center p-1">
                              <input type="number" min="1" [max]="totalPages"
                                     class="form-control form-control-sm py-0 px-1 me-1" style="width: 70px;"
                                     [(ngModel)]="pageInputValue"
                                     (keyup.enter)="goToPage()" (keyup.escape)="cancelPageJump()"
                                     (click)="$event.stopPropagation()"
                                     placeholder="1-{{ totalPages }}" />
                              <button type="button" class="btn btn-sm btn-primary py-0 px-2" (click)="goToPage()">
                                  {{ 'TRANSLATIONS.GO' | translate }}
                              </button>
                          </span>
                          <ng-template #ellipsisDots>
                              <a class="page-link cursor-pointer" (click)="startPageJump(i)" title="{{ 'TRANSLATIONS.GO_TO_PAGE' | translate }}">…</a>
                          </ng-template>
                      </ng-container>
                      <ng-template #normalPage>
                          <a class="page-link cursor-pointer" (click)="onPageChange(page)">{{ page }}</a>
                      </ng-template>
                  </li>
                  <!-- Next Button -->
                  <li class="page-item" [class.disabled]="currentPage === totalPages">
                      <a class="page-link cursor-pointer" (click)="onPageChange(currentPage + 1)">
          {{ 'TRANSLATIONS.NEXT' | translate }}
          </a>
                  </li>
              </ul>
          </div>
      </div>
  </div>
  <ng-template #noPhoneNumbers>
      <div class="alert alert-warning" role="alert">
          {{ 'CAMPAIGN.NO_NUMBERS' | translate }}
      </div>
  </ng-template>
  <ng-template #noContactsInfo>
      <div class="alert alert-info" role="alert">
          {{ 'CAMPAIGN.NO_CONTACTS' | translate }}
      </div>
  </ng-template>